// src/components/LandingPage.jsx

import React, { useState } from "react";
import { Box, Typography, Button, Grid, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SignUp from "./SignUp";

const LandingPage = () => {
  const navigate = useNavigate();
  const [openSignUp, setOpenSignUp] = useState(false);

  const handleOpenSignUp = () => setOpenSignUp(true);
  const handleCloseSignUp = () => setOpenSignUp(false);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#2F4E8B",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Grid container spacing={4} justifyContent="center" sx={{ maxWidth: 400 }}>
        {/* Title */}
        <Grid item xs={12} textAlign="center">
          <Typography
            variant="h3"
            sx={{ color: "#fff", fontWeight: "bold", mb: 1 }}
          >
            Tallentum
          </Typography>
          <Typography variant="subtitle1" sx={{ color: "#eee", mb: 3 }}>
       2025
          </Typography>
        </Grid>

        {/* Se connecter button */}
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="contained"
            onClick={() => navigate("/connexion")}
            sx={{
              bgcolor: "#fff",
              color: "#2F4E8B",
              py: 1.5,
              borderRadius: 2,
              fontWeight: "bold",
              "&:hover": { bgcolor: "#f0f0f0" },
            }}
          >
            Se connecter
          </Button>
        </Grid>

        {/* S'inscrire button */}
    
      </Grid>

      {/* Full-screen SignUp Modal */}
      <Modal open={openSignUp} onClose={handleCloseSignUp}>
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            bgcolor: "#fff",
            p: 2,
            overflow: "auto",
          }}
        >
          {/* Pass handleClose so SignUp can call it */}
          <SignUp handleClose={handleCloseSignUp} />
        </Box>
      </Modal>
    </Box>
  );
};

export default LandingPage;
